import { render, staticRenderFns } from "./basic-chart-visualizer.vue?vue&type=template&id=229e74bf&scoped=true&"
import script from "./basic-chart-visualizer.vue?vue&type=script&lang=js&"
export * from "./basic-chart-visualizer.vue?vue&type=script&lang=js&"
import style0 from "./basic-chart-visualizer.vue?vue&type=style&index=0&id=229e74bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229e74bf",
  null
  
)

export default component.exports